import styled from "styled-components";
import { RowGrid } from "../../../Styling/Grids/RowGrid";
import { OverflowContainerVertical } from "../../../Styling/OverflowContainers/OverflowContainerVertical";
import { VariableManualPanelStyling } from "./PanelStylings";
export const LinkPanelStyling = styled(RowGrid) `
  ${VariableManualPanelStyling};
  ${OverflowContainerVertical};
`;
